import React, { useRef, useState } from "react";

const shortsData = [
  { 
    id: 1, 
    title: "How to trade in stock market in 30 seconds 🔥", 
    src: "https://www.youtube.com/embed/N1n7v3VZrqU?autoplay=1&mute=1&loop=1&playlist=N1n7v3VZrqU" 
  },
  { 
    id: 2, 
    title: "Intraday secret strategy", 
    src: "https://www.youtube.com/embed/zNv-5-5Me8o?autoplay=1&mute=1&loop=1&playlist=zNv-5-5Me8o" 
  },
  { 
    id: 3, 
    title: "Option buying vs option selling explained", 
    src: "https://www.youtube.com/embed/qYa2UOdIraA?autoplay=1&mute=1&loop=1&playlist=qYa2UOdIraA" 
  },
];

const YouTubeShortsSection = () => {
  const rowRef = useRef(null);
  const iframeRefs = useRef([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleVideoClick = (index) => {
    setActiveIndex(index);
    iframeRefs.current.forEach((frame, i) => {
      if (!frame) return;

      const embedUrl = shortsData[i].src;
      if (i === index) {
        frame.src = embedUrl.replace("mute=1", "mute=0");
      } else {
        frame.src = embedUrl.replace("mute=0", "mute=1");
      }
    });
  };

  const scrollRow = (direction) => {
    const container = rowRef.current;
    if (!container) return;

    const firstCard = container.querySelector(".yt-shorts-card");
    const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 180;

    container.scrollBy({
      left: direction === "left" ? -cardWidth * 2 : cardWidth * 2,
      behavior: "smooth",
    });
  };

  return (
    <div className="yt-shorts-wrapper">
      <div className="yt-shorts-header">
        <span className="yt-shorts-text">Shorts</span>

        <div>
          <button onClick={() => scrollRow("left")}>‹</button>
          <button onClick={() => scrollRow("right")}>›</button>
        </div>
      </div>

      <div className="yt-shorts-row" ref={rowRef}>
        {shortsData.map((short, index) => {
          const isActive = activeIndex === index;
          return (
            <div
              key={short.id}
              className="yt-shorts-card"
              onClick={() => handleVideoClick(index)}
            >
              <div className="yt-shorts-thumb-wrapper">
                <iframe
                  ref={(el) => (iframeRefs.current[index] = el)}
                  className="yt-shorts-thumb"
                  src={short.src}
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title={short.title}
                ></iframe>

                <div className="yt-sound-icon">{isActive ? "🔊" : "🔇"}</div>
              </div>
              <div className="collection-title">{short.title}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default YouTubeShortsSection;
